export function pilatesQuickActions({
  openTodaySessions,
  openTakePayment,
  openCreateMember, // ✅ EKLENDİ
  navigate,
}) {
  return [
    {
      key: 'today',
      icon: 'today',
      title: 'Bugün',
      desc: 'Bugünkü seansları ve katılımcıları gör.',
      color: 'info',
      variant: 'gradient',
      ctaLabel: 'Aç',
      onClick: openTodaySessions,
    },

    {
      key: 'take_payment',
      icon: 'payments',
      title: 'Ödeme Al',
      desc: 'Paket / Seans / Diğer tahsilat.',
      color: 'warning',
      ctaLabel: 'Aç',
      onClick: openTakePayment,
    },

    {
      key: 'new_member',
      icon: 'person_add',
      title: 'Üye Ekle',
      desc: 'Üye kaydı aç, paket seç ve ilk ödemeyi al.',
      color: 'success',
      ctaLabel: 'Aç',
      onClick: openCreateMember, // ✅
    },
  ];
}
